import React from "react";
import "./Nav.css";
import { Link } from "react-router-dom";
import { useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import Music from "../Music/Music";

function Nav() {
  const navRef = useRef();

  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };

  return (
    <div className="nav-section">
      <div className="logo" title="Logo">
        𝕬𝖑𝖑𝖆𝖍𝖛𝖊𝖗𝖉𝖎𝖞𝖊𝖛
      </div>
      <Music />

      <button className="nav-btn" onClick={showNavbar}>
        <FaBars />
      </button>

      <div className="navs">
        <nav ref={navRef}>
          <ul>
            <li>
              <a className="nav" href="/">
                Home
              </a>
              <a className="nav" href="/projects">
                Projects
              </a>
              <a className="nav" href="/About">
                About
              </a>
            </li>
          </ul>

          <button className="nav-btn nav-close-btn" onClick={showNavbar}>
            <FaTimes />
          </button>
        </nav>
      </div>
    </div>
  );
}

export default Nav;
